<template>
    <v-container class="main-container">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">契約先企業一覧</v-col>
                <template v-if="user.role == true"> <!-- 管理者 -->
                    <v-col cols="12" xl="12" class="text-right">
                        <v-btn color="red" class="white--text" @click="clickAddUser">契約先企業を追加する</v-btn>
                        <br>
                        <v-btn color="orange" class="white--text" @click="downloadCSV">CSVエクスポート</v-btn>
                        <input id="fileUpload" name="csv" class="file_input" type="file" ref="file" @change="uploadCSV" accept="text/csv" hidden>
                        <v-btn @click="chooseFiles" color="orange" class="white--text">CSVインポート</v-btn>
                    </v-col>
                    
                </template>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>企業名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-text-field v-model="searchItem.company_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <badge-component tile color="unset">
                                        <label-component>備考欄</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-text-field v-model="searchItem.remarks" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn
                                            color="blue"
                                            class="white--text"
                                            type="submit"
                                        >
                                            検索
                                        </v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.company_name }}</td>
                            <td class="item-td" align="center">{{ item.remarks }}</td>
                            <td align="center">
                                <template v-if="user.role == true"> <!-- 管理者 -->
                                    <v-btn color="blue" class="white--text" @click="clickDetail(item)">詳細</v-btn>
                                </template>
                            </td>
                            <td align="center">
                                <template v-if="user.role == true"> <!-- 管理者 -->
                                    <v-btn color="blue-grey" class="white--text" @click="clickDelete(item)">削除</v-btn>
                                </template>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>
  
        <!-- 契約先企業追加 -->
        <contract-destination-companies-add-dialog-component v-if="addDialog" :addDialog.sync="addDialog" @success="reSearch" @error="error">
            <template v-slot:message>契約先企業追加</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </contract-destination-companies-add-dialog-component>

        <!-- 詳細 -->
        <contract-destination-companies-dialog-component v-if="detailDialog" :detailDialog.sync="detailDialog" :item="{id: currentItem.id, company_name: currentItem.company_name, remarks: currentItem.remarks}" @success="reSearch" @error="error">
            <template v-slot:message>詳細</template>
            <template v-slot:ok-btn>保存</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </contract-destination-companies-dialog-component>

        <!-- 削除 -->
        <delete-dialog-component v-if="deleteDialog" :deleteDialog.sync="deleteDialog" :item="{id: currentItem.id, table: '/documents/delete-contract-destination-companies/'}" @success="reSearch" @error="error">
            <template v-slot:title>{{ currentItem.company_name }}を削除しますか？</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    import moment from "moment";
    export default {
        props: ['user'],
        data() {
            return {
                // 項目一覧
                items: [],
                // 検索項目
                searchItem: {
                    remarks: '',
                    company_name: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: '企業名', align: 'center', value: 'company_name', width: '20%' },
                  { text: '備考欄', align: 'center', value: 'remarks', width: '60%' },
                  { text: '', value: 'action', sortable: false },
                  { text: '', value: 'action', sortable: false },
                ],
                // 契約先企業追加 開閉フラグ
                addDialog: false,
                // 詳細 開閉フラグ
                detailDialog: false,
                // 削除 開閉フラグ
                deleteDialog: false,
                // メッセージ
                message: {
                    success: false,
                    text: '',
                },
           };
        },
        methods: {
            // 契約先企業追加ボタン押下
            clickAddUser(item) {
                this.addDialog = true;
                this.currentItem = item;
           },
            // 詳細ボタン押下
            clickDetail(item) {
                this.detailDialog = true;
                this.currentItem = item;
            },
            // 削除ボタン押下
            clickDelete(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            chooseFiles: function() {
                document.getElementById("fileUpload").click();
            },
            // 検索
            search() {
                var self = this;
                axios.post('/documents/search-contract-destination-companies', this.searchItem).then((res) => {
                    self.items = res.data.items;
                });
            },
            // 再検索
            reSearch(message) {
                var self = this;
                axios.post('/documents/search-contract-destination-companies', this.searchItem).then((res) => {
                    self.items = res.data.items;
                    self.message.success = true;
                    self.message.text = message;
                });
            },
            downloadCSV () {
                var csv = '\ufeff' + '会社ID,会社名,備考欄\n';
                var fileName = '契約先企業一覧' + moment().format( "YYYY年MM月DD日" ) + '時点';
                this.items.forEach(el => {
                    var line = el['id'] + ',' + el['company_name'] + ',' + el['remarks'] +  '\n';
                    csv += line;
                });
                let blob = new Blob([csv], { type: 'text/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName + '.csv';
                link.click();
                
                window.axios.post('/documents/operation-log/save', {
                    display_name: '契約先企業一覧',
                    operation: '契約先企業エクスポート',
                    table_name: '契約先企業',
                });
            },
            uploadCSV(e){
                const formData = new FormData();
                let config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                const files = e.target.files || e.dataTransfer.files;
                formData.append('file',files[0]);
                // ファイルサイズ
                if (files[0].size > (20 * 1024 * 1024)) {
                    this.message.text = "1ファイルのサイズは最大20MBまでです";
                    this.message.success = false;
                    this.$refs.file.value = null;
                    return false;
                }
                // // 企業名
                // if (!this.name) {
                //     this.errors.push("Name required.");
                // }
                var self = this;
                window.axios
                    .post('/documents/contract-destination-companies-import-csv', formData, config)
                    .then(function (response) {
                        if(response.data.success){
                            self.items = response.data.items;
                            self.message.success = true;
                            self.message.text = "インポート処理が完了しました";
                        } else {
                            self.message.success = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "インポート処理に失敗しました";
                            }
                        }
                    })
                    .catch(function (response) {
                        console.log(response);
                        self.message.text = "インポート処理に失敗しました";
                        self.message.success = false;
                    })
                    .finally(function () {
                        self.$refs.file.value = null;
                    })
                ;
            },
            // エラー
            error(message) {
                this.message.success = false;
                this.message.text = message;
            }
        },
        // 初期表示のデータ
        mounted() {
            var self = this;
            axios.get('/documents/get-contract-destination-companies').then((res) => {
                self.items = res.data.items;
            });
        },
        computed: {
            // メッセージ
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
    };
</script>

<style scoped>
    .file_input {
        display: none;
    }
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>